module.exports = __webpack_public_path__ + "img/dashboard.9ae9148e.png";